/**
 * The "Custom" licence selection: the org gets a licence of its own, starting
 * with nothing enabled, instead of being put on a shared tier.
 *
 * Not a real `license_id` — no such row exists. `registerAccount` mints the
 * licence when the input carries no `license_id`, so the wizard sends none.
 *
 * Lives apart from the licence step so the container and its tests can read it
 * without pulling in the step component.
 */
export const CUSTOM_LICENSE_ID = 'custom';
